var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoWayArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.51398C17.9997 6.67259 17.9315 6.82459 17.8104 6.93656L13.6046 10.8255C13.3524 11.0587 12.9443 11.0581 12.693 10.8241C12.4416 10.5902 12.4423 10.2116 12.6945 9.97841L15.7975 7.10917L7.64367 7.09822C7.28766 7.09775 6.99948 6.82962 7 6.49934C7.00051 6.16906 7.28953 5.9017 7.64553 5.90218L15.8009 5.91313L12.693 3.02018C12.4416 2.78625 12.4423 2.40761 12.6945 2.17445C12.9466 1.9413 13.3548 1.94193 13.6061 2.17586L17.812 6.09083C17.9326 6.20316 18.0003 6.35538 18 6.51398Z",
    fill: "#061556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09101e-06 13.514C0.000285575 13.6726 0.0684717 13.8246 0.189559 13.9366L4.39544 17.8255C4.6476 18.0587 5.05573 18.0581 5.30704 17.8241C5.55836 17.5902 5.55768 17.2116 5.30553 16.9784L2.20249 14.1092L10.3563 14.0982C10.7123 14.0977 11.0005 13.8296 11 13.4993C10.9995 13.1691 10.7105 12.9017 10.3545 12.9022L2.19912 12.9131L5.30704 10.0202C5.55836 9.78625 5.55768 9.40761 5.30553 9.17445C5.05338 8.9413 4.64524 8.94193 4.39393 9.17586L0.188042 13.0908C0.067357 13.2032 -0.000283393 13.3554 1.09101e-06 13.514Z",
    fill: "#061556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoWayArrow);
export default __webpack_public_path__ + "static/media/two-way-arrow.f1cb6a2f2bf81e52eeac20ccbd5195c5.svg";
export { ForwardRef as ReactComponent };